<script setup>
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import AppShell from '@/layouts/AppShell.vue';

const route = useRoute();
// Routes can opt out of the nav chrome (e.g. the login page).
const withChrome = computed(() => route.meta?.chrome !== false);
</script>

<template>
  <AppShell v-if="withChrome" />
  <RouterView v-else />
</template>
